import React from 'react';
import { Plus, Eye, Edit, Trash2, Copy, RefreshCw } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Link } from 'react-router-dom';
export function ManageCourses() {
  const courses = [{
    pos: 1,
    courseNo: 'CD17355',
    name: 'Ethics & The Rules (with NAR Code of Ethics)',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 2,
    courseNo: 'None',
    name: 'NAR Code of Ethics (NO CE CREDIT)',
    sections: 5,
    questions: 27,
    passing: 80,
    price: '$14.95  (N)',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 3,
    courseNo: 'FWD17590',
    name: 'Deeds, Fires & Water: Be Prepared',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 5,
    courseNo: 'CD16995',
    name: 'Are They Represented?',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 6,
    courseNo: 'CD18311',
    name: 'Mastering Agency Agreements',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 8,
    courseNo: 'CD16991',
    name: 'A Letter From ADRE',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 9,
    courseNo: 'CD17085',
    name: "Don't Lose Your License",
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 10,
    courseNo: 'CD17707',
    name: 'BMC #1 AZ Residential-Statutes and Rules',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 11,
    courseNo: 'CD17708',
    name: 'BMC #2 AZ Residential-Broker Policies',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 12,
    courseNo: 'CD17709',
    name: 'BMC #3 AZ Residential-Broker Supervision',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 13,
    courseNo: 'CD18092',
    name: 'BMC #3B Property Management',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 14,
    courseNo: 'CD16990',
    name: 'What Goes Wrong In Contracts',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 15,
    courseNo: 'CD18093',
    name: 'Avoid The Oops: Contract Smarts for Agents',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 17,
    courseNo: 'CD16992',
    name: 'No Secrets',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 18,
    courseNo: 'CD18149',
    name: 'The Bottom Line of Disclosure',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 19,
    courseNo: 'CE15753',
    name: 'Your Clients Are Not Mushrooms',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 20,
    courseNo: 'CD16993',
    name: 'They Are A Protected Class',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 21,
    courseNo: 'CD15797',
    name: "Fair Housing In Today's World",
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: 'They Are A Protected Class'
  }, {
    pos: 23,
    courseNo: 'CE17700',
    name: 'Accidental Property Management',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }, {
    pos: 24,
    courseNo: 'CD16994',
    name: 'Follow All The Laws',
    sections: 5,
    questions: 25,
    passing: 80,
    price: '$19.95',
    published: 'Yes',
    renewedTo: ''
  }];
  return <div className="space-y-6" data-id="element-432">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-433">Manage Courses</h1>

      <div className="mb-4" data-id="element-434">
        <Button variant="secondary" size="sm" className="gap-2 border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm hover:from-slate-50 hover:to-slate-200" data-id="element-435">
          <Plus className="h-4 w-4 text-green-600" data-id="element-436" />
          Add
        </Button>
      </div>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-437">
        <div className="overflow-x-auto" data-id="element-438">
          <table className="w-full text-sm text-left" data-id="element-439">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-440">
              <tr data-id="element-441">
                <th className="px-2 py-3 border-r border-slate-700 text-center w-16" data-id="element-442">
                  Position
                </th>
                <th className="px-3 py-3 border-r border-slate-700 w-24" data-id="element-443">
                  Course No
                </th>
                <th className="px-4 py-3 border-r border-slate-700 text-center" data-id="element-444">
                  Name
                </th>
                <th className="px-2 py-3 border-r border-slate-700 text-center w-16" data-id="element-445">
                  Sections
                </th>
                <th className="px-2 py-3 border-r border-slate-700 text-center w-20" data-id="element-446">
                  Questions
                </th>
                <th className="px-2 py-3 border-r border-slate-700 text-center w-20" data-id="element-447">
                  Passing(%)
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-448">
                  Price
                </th>
                <th className="px-2 py-3 border-r border-slate-700 text-center w-20" data-id="element-449">
                  Published
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-32" data-id="element-450">
                  Renewed To
                </th>
                <th className="px-4 py-3 text-center w-44" data-id="element-451">
                  <div data-id="element-452">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-453">
                    View | Edit | Delete | Clone | Renew
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-454">
              {courses.map(course => <tr key={course.pos} className="hover:bg-slate-50" data-id="element-455">
                  <td className="px-2 py-3 border-r border-slate-200 text-center" data-id="element-456">
                    {course.pos}
                  </td>
                  <td className="px-3 py-3 border-r border-slate-200" data-id="element-457">
                    {course.courseNo}
                  </td>
                  <td className="px-4 py-3 border-r border-slate-200" data-id="element-458">
                    {course.name}
                  </td>
                  <td className="px-2 py-3 border-r border-slate-200 text-center" data-id="element-459">
                    <Link to="/sections" className="text-blue-600 hover:underline" data-id="element-460">
                      {course.sections}
                    </Link>
                  </td>
                  <td className="px-2 py-3 border-r border-slate-200 text-center" data-id="element-461">
                    {course.questions}
                  </td>
                  <td className="px-2 py-3 border-r border-slate-200 text-center" data-id="element-462">
                    {course.passing}
                  </td>
                  <td className="px-3 py-3 border-r border-slate-200" data-id="element-463">
                    {course.price}
                  </td>
                  <td className="px-2 py-3 border-r border-slate-200 text-center" data-id="element-464">
                    {course.published}
                  </td>
                  <td className="px-3 py-3 border-r border-slate-200 text-slate-700" data-id="element-465">
                    {course.renewedTo}
                  </td>
                  <td className="px-4 py-3 text-center" data-id="element-466">
                    <div className="flex items-center justify-center gap-2" data-id="element-467">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" data-id="element-468">
                        <Eye className="h-4 w-4" data-id="element-469" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" data-id="element-470">
                        <Edit className="h-4 w-4" data-id="element-471" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-472">
                        <Trash2 className="h-4 w-4" data-id="element-473" />
                      </button>
                      <button title="Clone" className="p-1 text-slate-500 hover:text-blue-600" data-id="element-474">
                        <Copy className="h-4 w-4" data-id="element-475" />
                      </button>
                      <button title="Renew" className="p-1 text-slate-500 hover:text-green-600" data-id="element-476">
                        <RefreshCw className="h-4 w-4" data-id="element-477" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>

      <div className="text-sm text-blue-600 flex items-center gap-1 mt-2" data-id="element-478">
        <button className="hover:underline" data-id="element-479">&lt;&lt; previous</button>
        <span className="text-slate-400" data-id="element-480">|</span>
        <span className="text-slate-900 font-medium" data-id="element-481">1</span>
        <span className="text-slate-400" data-id="element-482">|</span>
        <button className="hover:underline" data-id="element-483">2</button>
        <span className="text-slate-400" data-id="element-484">|</span>
        <button className="hover:underline" data-id="element-485">3</button>
        <span className="text-slate-400" data-id="element-486">|</span>
        <button className="hover:underline" data-id="element-487">next &gt;&gt;</button>
      </div>
    </div>;
}